import { useState, useContext } from 'react';
import SubmitBtn from '../../Form/submit-button/submit-button.component';
import comSign from '../../../assets/img/comsign.png';
import tamuzCard from '../../../assets/img/tamuz-card.png';
import personalId from '../../../assets/img/personalID.png';
import idCard from '../../../assets/icons/id-card.svg';
import smartCardReader from '../../../assets/icons/smart-card-reader.svg';
import code from '../../../assets/icons/code-stars.svg';
import './smart-card.scss';
import classes from './osc.module.scss';
import LoginContext from '../../../store/login-context';
import scImg from '../../../assets/img/smart_card.svg';
import arrowRightBlue from '../../../assets/icons/arrow-right-blue.svg';
import outlineRepeat from '../../../assets/icons/outline_repeat.svg';
import BackLink from '../../General/Static/BackLink/BackLink';

declare function Translate(key: string): string;
declare var _loginMethodComsignCardUrl;
declare var _loginMethodPersonalIDCardUrl;
declare var _loginMethodTamuzCardUrl;
declare var _curLang: any;
declare var _loginMethodSmsOtpUrl: any;
declare var _loginType: any;
declare var _loginTypeLoa4Landing: any;

const OldSmartCard = props => {  
  
  const ctx = useContext(LoginContext);
  
  const [selectedCard, setSelectedCard] = useState('');  
  const [isCardSelected, setIsCardSelected] = useState(false);

  const cardTypes = {
    comSign: 'comSign',
    tamuz: 'tamuz',
    personalId: 'personalId',
  }

  const cardTypesContainer = {
    comSign: 'comSignContainer',
    tamuz: 'tamuzContainer',
    personalId: 'personalIdContainer',
  }

  const btnClick = () => {
    switch (selectedCard) {
      case cardTypes.comSign:
        window.location.href = _loginMethodComsignCardUrl;
        break;
      case cardTypes.tamuz:
        window.location.href = _loginMethodTamuzCardUrl;
        break;
      case cardTypes.personalId:
        window.location.href = _loginMethodPersonalIDCardUrl;
        break;
      default:
        break;
    }
  };

  const handleCardChange = (radioId) => { 
    setSelectedCard(radioId);
    setIsCardSelected(true); 
    
    switch (radioId){
      case cardTypes.comSign:
        document.getElementById(cardTypesContainer.comSign)?.setAttribute('aria-checked','true');
        document.getElementById(cardTypesContainer.tamuz)?.setAttribute('aria-checked','false');
        document.getElementById(cardTypesContainer.personalId)?.setAttribute('aria-checked','false');
        break;
      case cardTypes.tamuz:
        document.getElementById(cardTypesContainer.tamuz)?.setAttribute('aria-checked','true');
        document.getElementById(cardTypesContainer.comSign)?.setAttribute('aria-checked','false');
        document.getElementById(cardTypesContainer.personalId)?.setAttribute('aria-checked','false');
        break;
      case cardTypes.personalId:
        document.getElementById(cardTypesContainer.personalId)?.setAttribute('aria-checked','true');
        document.getElementById(cardTypesContainer.tamuz)?.setAttribute('aria-checked','false');
        document.getElementById(cardTypesContainer.comSign)?.setAttribute('aria-checked','false');
        break;
      default:
        break;
    }
  }

  const cardChangeKeyPressHandler = (event,radioId) => {
    event.preventDefault();
    if (event.charCode === 13 || event.charCode === 32){
      handleCardChange(radioId);
    }
  }

  const goToNewVersion = () => {
    ctx.toggleCard();    
  };

  const onKeyNewVersion = (event) => {
    event.preventDefault();
    if (event.charCode === 13 || event.charCode === 32){
      goToNewVersion();
    }
  };
   
  const onBackHandler = () => {
    window.location = _loginMethodSmsOtpUrl;
  }

  const onBioIdHandler = () => {
    ctx.bioIdSelected();
  }

  const onBackPress = (event) => {
    event.preventDefault();
    if (event.charCode === 13 || event.charCode === 32){
      onBackHandler();
    }
  };

  return (
    <>
      {/* <div className={classes.up_note}>
        <h1 className={classes.title}>{Translate('N_Login_info_1')}</h1>
      </div> */}
      <div className="sc_landing_wrapper">
        <form className='normal-form'>
          {_loginType !== _loginTypeLoa4Landing &&
            <BackLink back={onBackHandler} loginType="" translate={Translate('N_Login_application_pop_up_3')}/>
          }
          {_loginType === _loginTypeLoa4Landing && 
            <BackLink back={onBioIdHandler} loginType="Loa4Landing" translate={Translate('N_Login_biometric_id_tab_title')}/>
          }                                             
          <div className='loginHeading'>
            <img
              className=''
              src={scImg}
                          
            />
            <div className='title'>
              <span>{Translate('N_Login_SmartCard_title')}</span>
            </div>
          </div>

          <div className='smart-card-form mt-2 mainFormZone'>                  
            <div className='sc-form-description mt-4'>
              <span>
                {Translate('N_Login_smart_card_info_1')}
              </span>
              <section className='methods my-3'>
                <div className='method'>
                  <img src={smartCardReader} alt='' aria-hidden="true"/>                  
                  <span>
                    {Translate('N_Login_smart_card_info_4')}
                    <a className='gov-tooltip tooltipLink' tabIndex={0} role='button'>
                      {Translate('N_Login_biometric_id_info_title_4')}
                      <span className="gov-tooltiptext" tabIndex={0}>{Translate('N_Login_biometric_id_info_reader')}</span>
                    </a>
                  </span>              
                </div>
                <div className='method'>
                  <img src={idCard} alt='' aria-hidden="true"/>                  
                  <span>
                    {Translate('N_Login_smart_card_info_2')}
                    <a className='gov-tooltip tooltipLink' tabIndex={0} role='button'>{Translate('N_Login_Bio_ID_What_is_biometric_ID')}
                      <span className="gov-tooltiptext" tabIndex={0}>{Translate('N_Login_smart_card_info_6')}</span>
                    </a>  
                  </span>              
                </div>
                <div className='method'>
                  <img src={code} alt='' aria-hidden="true"/>                                          
                  <span>{Translate('N_Login_smart_card_info_3')}</span>
                </div>                
              </section>
            </div>

            <div className='sc-images-title mb-1'>          
              {Translate('N_Login_smart_card_info_title_old_version')}:
            </div>

            <div className='smart-card-radios mt-2' role="radiogroup" aria-required="true">   
              <div 
                id='tamuzContainer'
                tabIndex={0}
                role="radio"
                aria-checked="false"
                className='radio-method ms-2' 
                onClick={() => handleCardChange(cardTypes.tamuz)}
                onKeyPress={(event) => cardChangeKeyPressHandler(event,cardTypes.tamuz)}
              >
                <input
                  tabIndex={-1}
                  type='radio'
                  name='identificationMethod'
                  id={cardTypes.tamuz}
                  value={cardTypes.tamuz}
                  checked={selectedCard === cardTypes.tamuz}
                  readOnly
                />
                <img
                  className='radio-image'
                  src={tamuzCard}
                  alt=''
                  aria-hidden="true"
                />
                <div className='radio-label'>
                  {Translate('N_Login_smart_card_Tamuz')}
                </div>
              </div>                  
              <div 
                id='comSignContainer'
                tabIndex={0} 
                role="radio"
                aria-checked="false"
                onClick={() => handleCardChange(cardTypes.comSign)}
                onKeyPress={(event) => cardChangeKeyPressHandler(event,cardTypes.comSign)}
                className={
                  'radio-method ' +
                  (_curLang === 'en' || _curLang === 'ru' ? 'me-2' : 'ms-2')
                }
              >
                <input
                  tabIndex={-1}
                  type='radio'
                  name='identificationMethod'
                  id={cardTypes.comSign}                      
                  value={cardTypes.comSign}
                  checked={selectedCard === cardTypes.comSign} 
                  readOnly 
                />
                <img className='radio-image' src={comSign} alt='' aria-hidden="true" />
                <div className='radio-label'>
                  {Translate('N_Login_smart_card_Comsign')}
                </div>
              </div>                                                   
              <div 
                id='personalIdContainer'
                tabIndex={0}
                role="radio"
                aria-checked="false"
                className='radio-method ms-2' 
                onClick={() => handleCardChange(cardTypes.personalId)}
                onKeyPress={(event) => cardChangeKeyPressHandler(event,cardTypes.personalId)}
              >
                <input
                  tabIndex={-1}
                  type='radio'
                  name='identificationMethod'
                  id={cardTypes.personalId}
                  value={cardTypes.personalId}
                  checked={selectedCard === cardTypes.personalId}
                  readOnly
                />
                <img
                  className='radio-image'
                  src={personalId}
                  alt=''
                  aria-hidden="true"
                />
                <div className='radio-label'>
                  {Translate('N_Login_smart_card_Personal_ID')}
                </div>
              </div>
            </div>
            <SubmitBtn
              title={Translate('N_Login_smart_card_button')}
              id="oldScSubmit"
              action={btnClick}
              showIcon={true}
              disabled={!isCardSelected}
            />            
                    
            <div className='d-flex align-items-center justify-content-center mt-4'>
              <div className='old-sc-version'>{Translate('N_Login_smart_card_problem')} </div>
              <div id='toNewVersion' className='old-sc-version-link'
                tabIndex={0}
                onClick={goToNewVersion}
                onKeyPress={onKeyNewVersion}
              >
                  <span>{Translate('N_Login_smart_card_back_new_version')}</span>                
              </div> 
            </div>

            {/* <NavigationButtons /> */}

          </div>
        </form> 
      </div> 
    </> 
  );

};
export default OldSmartCard;

